import { Component, OnInit } from '@angular/core';
import { SplitViewService } from '@ebw-monorepo/utils';
import { SplitViewConf, SplitViewLayoutConf } from 'libs/ng-components/utils/src/lib/models/split-view-conf';

@Component({
  selector: 'ebw-monorepo-split-portal',
  templateUrl: './split-portal.component.html',
  styleUrls: ['./split-portal.component.scss']
})
export class SplitPortalComponent implements OnInit {
  

  public conf: SplitViewConf = {
    title: '',
    icon: 'featured_play_list'
  };

  public layoutConf: SplitViewLayoutConf = {
    isEnable: true,
    halfScreen: true,
    collapsed: false
  };

  constructor(
    private _splitViewService: SplitViewService
  ) { }

  ngOnInit(): void {
    this._splitViewService.viewConfig$.subscribe((event) => {
      if (!event) {
        return;
      }

      this.conf = event;
    });

    this._splitViewService.viewLayountConfig$.subscribe((event) => {
      if (!event) {
        return;
      }

      this.layoutConf = event;
    });
  }

  public showFullOrHalf() {
    const conf = {
      isEnable: true,
      halfScreen: !this.layoutConf.halfScreen,
      collapsed: false
    }

    this._splitViewService.layoutConfChange(conf);
  }

  public collapseOrExpand() {
    const conf = {
      isEnable: true,
      halfScreen: true,
      collapsed: !this.layoutConf.collapsed
    }

    this._splitViewService.layoutConfChange(conf);
  }

  public close() {
    const conf = {
      isEnable: false,
      halfScreen: true,
      collapsed: false
    }

    this._splitViewService.layoutConfChange(conf);
  }
}
